"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const hooks_1 = require("../hooks");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
// @ts-ignore
const i18n_1 = require("@completeanatomy/i18n");
const selectors_1 = require("../selectors");
function LanguageProvider({ children, i18n = i18n_1.i18n, }) {
    const language = (0, hooks_1.useSelector)(selectors_1.getLanguage);
    (0, react_1.useEffect)(() => {
        i18n.changeLanguage(language);
        // eslint-disable-next-line
    }, [language]);
    return (0, jsx_runtime_1.jsx)(react_i18next_1.I18nextProvider, { i18n: i18n, "data-e2e": 'LanguageProvider_I18nextProvider', children: children });
}
exports.LanguageProvider = LanguageProvider;
